// extracted by mini-css-extract-plugin
export var appStoreIcon = "styles-module__appStoreIcon___WazYE";
export var container = "styles-module__container____zz6X";
export var content = "styles-module__content___IqLzm";
export var editorsChoiceContainer = "styles-module__editorsChoiceContainer___ukEa9";
export var headerText = "styles-module__headerText___jRKku";
export var mainText = "styles-module__mainText___f03ci";